<h4 mat-dialog-title>Modification propriétés champ de date.</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editDateInputForm" style="margin-top: 25px">
  <mat-dialog-content class="mat__typography">
    <div fxLayout="column" fxLayoutGap="15px">
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>{{placeholderTitle}}</mat-label>
          <input formControlName="placeholder" matInput
                 matTooltip="{{placeholderText}}"
                 placeholder="{{placeholderText}}"
                 type="text" data-cy="input-date-dialog-placeholder">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>Tooltip</mat-label>
          <input formControlName="tooltip" matInput
                 matTooltip="{{tooltipText}}"
                 placeholder="{{tooltipText}}"
                 type="text" data-cy="input-date-dialog-tooltip">
        </mat-form-field>
      </div>
      <div [formGroup]="options">
        Autoriser les jours:
        <section fxLayout="column">
          <mat-checkbox formControlName="publicDays" hidden data-cy="chkbx-date-input-dialog-public-days">fériés</mat-checkbox>
          <mat-checkbox formControlName="holidays" hidden data-cy="chkbx-date-input-dialog-holidays">de vacances scolaires</mat-checkbox>
          <mat-checkbox formControlName="closedDays" hidden data-cy="chkbx-date-input-dialog-closed-days">de fermeture de P8</mat-checkbox>
          <div fxLayout="row">
            <mat-checkbox fxFlex="15%" formControlName="saturday" data-cy="chkbx-date-input-dialog-saturday">Samedi</mat-checkbox>
            <mat-checkbox fxFlex="15%" formControlName="sunday" data-cy="chkbx-date-input-dialog-sunday">Dimanche</mat-checkbox>
          </div>
          <div fxLayout="row">
            <mat-checkbox fxFlex="15%" formControlName="monday" data-cy="chkbx-date-input-dialog-monday">Lundi</mat-checkbox>
            <mat-checkbox fxFlex="15%" formControlName="tuesday" data-cy="chkbx-date-input-dialog-tuesday">Mardi</mat-checkbox>
            <mat-checkbox fxFlex="15%" formControlName="wednesday" data-cy="chkbx-date-input-dialog-wednesday">Mercredi</mat-checkbox>
            <mat-checkbox fxFlex="15%" formControlName="thursday" data-cy="chkbx-date-input-dialog-thursday">Jeudi</mat-checkbox>
            <mat-checkbox fxFlex="15%" formControlName="friday" data-cy="chkbx-date-input-dialog-friday">Vendredi</mat-checkbox>
          </div>
        </section>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onNoClick()"
            mat-raised-button
            color="accent"
            type="button">
      Annuler
    </button>
    <button mat-raised-button
            cdkFocusInitial
            color="primary"
            type="submit">
      Sauvegarder
    </button>
  </mat-dialog-actions>
</form>

